import { render, staticRenderFns } from "./QuizBuilder.vue?vue&type=template&id=88008f38"
import script from "./QuizBuilder.vue?vue&type=script&lang=js"
export * from "./QuizBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports